// extracted by mini-css-extract-plugin
module.exports = {"years":"_2b-X_","selected":"pOqjZ"};